import React, {useEffect, useMemo, useState} from "react";
import {Avatar, Divider, Dropdown, Menu, Modal, Spin, Tooltip} from "antd";
import style from "./ProfileModal.module.scss";

import useFetch, {CachePolicies} from "use-http";
import {LoadingOutlined, UserAddOutlined, UserSwitchOutlined,} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import GroupContainer from "../../../pages/Profile/Groups/GroupContainer";
import GroupCard from "../../../pages/Profile/Groups/GroupCard";
import SkeletonCard from "../../../pages/Profile/Groups/SkeletonCard";
import {getNameProfile, getUrlHttp} from "src/service/util.service";
import {pathRoutes} from "src/props/util.props";
import UIModalReport from "../../../pages/Profile/modal/UIModalReport";
import ButtonCenterClose from "src/components/shared/button/CloseButton/ButtonCenterClose";

import chatIcon from "src/assets/png/newIcon/My Center/Friend detail/fill/Chat.png";
import callIcon from "src/assets/png/newIcon/My Center/Friend detail/fill/Call.png";
import conferenceIcon from "src/assets/png/newIcon/My Center/Friend detail/fill/Video conference.png";
import moreIcon from "src/assets/png/newIcon/My Center/Friend detail/fill/More detail.png";
import reportIcon from "src/assets/png/newIcon/My Center/Friend detail/fill/Report.png";
import blockIcon from "src/assets/png/newIcon/My Center/Friend detail/fill/Block.png";

import NoData from "src/components/shared/NoDataDisplay/NoData";
import {FRIEND_STATUS} from "../../../constants/Friend";
import {getUserData} from "../../../service/auth.service";
import UIModalConfirmBlock from "../../../pages/Profile/modal/UIModalConfirmBlock";

interface ProfileModalProps {
    visible: boolean
    userId: string
    onRefresh: () => void
    onClose: () => void
}

export const ProfileModal:React.FunctionComponent<ProfileModalProps> = (props) => {
    const { t } = useTranslation();

    const [profile, setProfile] = useState<any>();
    const [friendStatus, setFriendStatus] = useState<FRIEND_STATUS>();
    const [mutualGroups, setMutualGroups] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [toReport, setToReport] = useState<boolean>(false);
    const [showConfirmBlock, setShowConfirmBlock] = useState<boolean>(false);

    const noDataHeaderText = t("No Mutual Groups");
    const nodatatext = t("");


    const topic = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v2/groups/topic`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const voiceTopic = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v2/groups/topic`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const videoTopic = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v2/groups/topic`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const requestStatus = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/status-friend",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const addFriend = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/add-friend",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const acceptFriend = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/accept-friend",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const mutualGroup = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `/api/v1/users/detail`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const apiFriends = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/users/friends`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const apiUserProfile = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/users/detail`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    useEffect(() => {
        if (props.userId && props.visible) {
            getProfileData();
        } else {
            setProfile(undefined);
            setFriendStatus(undefined)
            setShowConfirmBlock(false);
            setToReport(false);
        }
    }, [props.userId, props.visible])

    // useEffect(() => {
    //     if (props.visible) return;
    //     setProfile(undefined);
    //     setFriendStatus(undefined)
    //     setShowConfirmBlock(false);
    //     setToReport(false);
    // }, [props.visible])

    const isMe = useMemo(() => {
        return profile?.id === getUserData()?.id
    }, [profile])
    //
    // const isMe = () => {
    //     return friend?.id === appCtx?.profile?.usernameProfile;
    // };

    const handleChat = async () => {
        const payload = {
            members: [{ userID: `${profile?.id}` }],
        };

        try {
            const res = await topic.post(payload);
            // navigate(pathRoutes.Chat + `?id=${res.id}`);

            // onRefresh?.();
            // onCancel();
        } catch (error) {
            console.error(error);
        }
    };

    const handleVoiceCall = async () => {
        const payload = {
            members: [{ userID: `${profile?.id}` }],
        };

        try {
            const res = await voiceTopic.post(payload);
            const path = `${pathRoutes.personalCall}?id=${res.id}&isVideoCall=false&calleeId=${profile?.id}`
            // navigate(path);

            // onRefresh?.();
            // onCancel?.();
        } catch (error) {
            console.error(error);
        }
    };

    const handleVideoCall = async () => {
        const payload = {
            members: [{ userID: `${profile?.id}` }],
        };

        try {
            const res = await videoTopic.post(payload);
            const path = `${pathRoutes.personalCall}?id=${res.id}&isVideoCall=true&calleeId=${profile?.id}`
            // navigate(path);

            // onRefresh?.();
            // onCancel?.();
        } catch (error) {
            console.error(error);
        }
    };

    const getProfileData = async () => {
        try {
            const res = await apiUserProfile.get(`/${props.userId}`);
            const statusRes = await apiFriends.get(`?mode=add&search=${props.userId}`);

            if (apiUserProfile.response.ok) {
                setProfile(res);
            }
            if (apiFriends.response.ok) {
                const isFriend = statusRes?.data?.length !== 0;
                setFriendStatus(isFriend ? FRIEND_STATUS.CONNECTED : FRIEND_STATUS.NOT_CONNECT)
            }

        } catch (err) {
            console.error(err);
        }
    }

    const connect = async () => {
        try {
            const res = await addFriend.post({ friendID: profile?.id });
            if (addFriend.response.ok) {
                if (res?.type === "request") {
                    setFriendStatus(FRIEND_STATUS.PENDING);
                } else if (res?.type === "accept") {
                    const mutual = await mutualGroup.get(`/${profile?.id}`);

                    setMutualGroups(mutual?.mutualGroups ? mutual?.mutualGroups : []);
                    setFriendStatus(FRIEND_STATUS.CONNECTED);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const acceptRequest = async () => {
        try {
            await acceptFriend.post({ friendID: profile?.id });
            if (acceptFriend.response.ok) {
                const mutual = await mutualGroup.get(`/${profile?.id}`);

                setMutualGroups(mutual?.mutualGroups ? mutual?.mutualGroups : []);
                setFriendStatus(FRIEND_STATUS.CONNECTED);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleAddFriend = async () => {
        setLoading(true);
        try {
            const status = await requestStatus.get(`?id=${profile?.id}`);

            if (requestStatus.response.ok) {
                if (status?.friendID === profile?.id) {
                    setFriendStatus(FRIEND_STATUS.PENDING);
                } else {
                    await acceptRequest();
                }
            }

            if (status?.code === 500) {
                await connect();
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    };

    useEffect(() => {
        return () => {
            topic.abort();
            voiceTopic.abort();
            videoTopic.abort();
            requestStatus.abort();
            acceptFriend.abort();
            addFriend.abort();
            mutualGroup.abort();
        };
    }, []);
    return (
        <Modal
            centered
            open={props.visible}
            className={style.modalOveride}
            onCancel={props.onClose}
        >
            <div className={style.popupContainer}>
                {/* <div
          className={style.closeBtn}
          style={{ backgroundImage: `url(${ProfilePopupIcon.closeIcon})` }}
          onClick={() => onClose()}
        /> */}
                <div style={{ position: "absolute", top: 19, right: 19 }}>
                    <ButtonCenterClose onClick={props.onClose} />
                </div>

                {!toReport && (
                    <div style={{ width: "100%" }} className={style.overrideScroll}>
                        <div className={style.profilePart}>
                            <Avatar src={getUrlHttp(profile?.imageProfileURL)} size={70}/>
                            {/*<div>*/}
                            {/*    <div*/}
                            {/*        className={style.profileImage}*/}
                            {/*        style={{*/}
                            {/*            backgroundImage: `url(${getUrlHttp(*/}
                            {/*                profile?.imageProfileURL*/}
                            {/*            )})`,*/}
                            {/*        }}*/}
                            {/*    ></div>*/}
                            {/*</div>*/}

                            <div className={style.profileDetailBox}>
                                <Tooltip
                                    placement="bottom"
                                    title={getNameProfile(profile?.firstname, profile?.lastname)}
                                >
                                    <div className={style.name}>{getNameProfile(profile?.firstname, profile?.lastname)}</div>
                                </Tooltip>
                                <div className={style.email}>{profile?.email}</div>
                                <div className={style.comunicationContainer}>
                                    {friendStatus === FRIEND_STATUS.NOT_CONNECT && !isMe && (
                                        <Tooltip placement="bottom" title={t("Connect")}>
                                            {!loading ? (
                                                <UserAddOutlined
                                                    style={{
                                                        width: 26,
                                                        height: 26,
                                                        fontSize: 25,
                                                        color: "#afafaf",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={handleAddFriend}
                                                />
                                            ) : (
                                                <LoadingOutlined
                                                    spin
                                                    style={{
                                                        width: 26,
                                                        height: 26,
                                                        fontSize: 25,
                                                        color: "#afafaf",
                                                    }}
                                                />
                                            )}
                                        </Tooltip>
                                    )}

                                    {friendStatus === FRIEND_STATUS.PENDING && !isMe && (
                                        <Tooltip placement="bottom" title={t("Requested")}>
                                            <UserSwitchOutlined
                                                style={{
                                                    width: 26,
                                                    height: 26,
                                                    fontSize: 25,
                                                    color: "#afafaf",
                                                }}
                                            />
                                        </Tooltip>
                                    )}

                                    {friendStatus === FRIEND_STATUS.CONNECTED && !isMe && (
                                        <>
                                            <Tooltip placement="bottom" title={t("Chat")}>
                                                {topic.loading ? (
                                                    <Spin
                                                        indicator={
                                                            <LoadingOutlined
                                                                style={{ fontSize: "28px", color: "#0f4c82" }}
                                                            />
                                                        }
                                                    />
                                                ) : (
                                                    <div
                                                        style={{ backgroundImage: `url(${chatIcon})` }}
                                                        className={style.communicateIcon}
                                                        onClick={handleChat}
                                                    />
                                                )}
                                            </Tooltip>
                                            <Tooltip placement="bottom" title={"Call"}>
                                                {voiceTopic.loading ? (
                                                    <Spin
                                                        indicator={
                                                            <LoadingOutlined
                                                                style={{ fontSize: "28px", color: "#0f4c82" }}
                                                            />
                                                        }
                                                    />
                                                ) : (
                                                    <div
                                                        style={{ backgroundImage: `url(${callIcon})` }}
                                                        className={style.communicateIcon}
                                                        onClick={handleVoiceCall}
                                                    />
                                                )}
                                            </Tooltip>
                                            <Tooltip placement="bottom" title={t("Video Conference")}>
                                                {videoTopic.loading ? (
                                                    <Spin
                                                        indicator={
                                                            <LoadingOutlined
                                                                style={{ fontSize: "28px", color: "#0f4c82" }}
                                                            />
                                                        }
                                                    />
                                                ) : (
                                                    <div
                                                        style={{
                                                            backgroundImage: `url(${conferenceIcon})`,
                                                        }}
                                                        className={style.communicateIcon}
                                                        onClick={handleVideoCall}
                                                    />
                                                )}
                                            </Tooltip>
                                        </>
                                    )}

                                    {!isMe && (
                                        <Dropdown
                                            overlay={
                                                <Menu>
                                                    { friendStatus === FRIEND_STATUS.CONNECTED &&
                                                    <Menu.Item
                                                        className={style.menuItem}
                                                        onClick={() => {
                                                            setShowConfirmBlock(true);
                                                        }}
                                                    >
                                                        <div style={{ display: "flex" }}>
                                                            <img
                                                                src={blockIcon}
                                                                style={{ width: 26, height: 26 }}
                                                            />
                                                            <div className={style.textMenu}>{t("block")}</div>
                                                        </div>
                                                    </Menu.Item>
                                                    }
                                                    <Menu.Item
                                                        className={style.menuItem}
                                                        onClick={() => {
                                                            setToReport(true);
                                                        }}
                                                    >
                                                        <div style={{ display: "flex" }}>
                                                            <img
                                                                src={reportIcon}
                                                                style={{ width: 26, height: 26 }}
                                                            />
                                                            <div className={style.textMenu}>
                                                                {t("report")}
                                                            </div>
                                                        </div>
                                                    </Menu.Item>
                                                </Menu>
                                            }
                                            placement="bottomCenter"
                                            arrow
                                            trigger={["click"]}
                                        >
                                            <img
                                                src={moreIcon}
                                                style={{ width: 26, height: 26, cursor: "pointer" }}
                                            />
                                        </Dropdown>
                                    )}
                                </div>
                            </div>
                        </div>
                        <Divider />
                        <div className={style.groupPart}>
                            <GroupContainer
                                header={t("Groups")}
                                number={profile?.mutualGroups ? profile?.mutualGroups?.length : 0}
                            >
                                <div className={style.cardGroup}>
                                    {profile?.mutualGroups === null ? (
                                        <SkeletonCard />
                                    ) : (
                                        profile?.mutualGroups?.map((group: any, idx: number) => {
                                            return (
                                                <GroupCard
                                                    key={idx}
                                                    image={group.coverImgURL}
                                                    member={null}
                                                    groupName={group.name}
                                                    favorite={true}
                                                    joined={true}
                                                    groupID={group.id}
                                                    onRefresh={() => {
                                                        props.onRefresh();
                                                        props.onClose();
                                                    }}
                                                    group={group}
                                                    isChat={false}
                                                />
                                            );
                                        })
                                    )}
                                </div>
                                {profile?.mutualGroups && profile?.mutualGroups?.length === 0 && (
                                    <NoData header={noDataHeaderText} detail={nodatatext} />
                                )}
                            </GroupContainer>
                        </div>
                    </div>
                )}
                {toReport && (
                    <UIModalReport
                        onClose={props.onClose}
                        profile={profile}
                        refId={profile?.id}
                    ></UIModalReport>
                )}
                {showConfirmBlock && (
                    <UIModalConfirmBlock
                        onRefresh={() => {
                            props?.onRefresh();
                            props?.onClose();
                        }}
                        onClose={() => {
                            setShowConfirmBlock(false);
                        }}
                        onCloseProfilePopup={() => {

                        }}
                        friend={profile}
                    ></UIModalConfirmBlock>
                )}
            </div>
        </Modal>
    );
};

